const Onlinecourses = () => {
    return (
        <>
            {/*Online Courses */}
            <section className="section student-course student-course-five">
                <div className="container">
                    <div className="course-widget-three">
                        <div className="row row-gap-4">
                            <div className="col-lg-2 col-md-6 d-flex" data-aos="fade-up">
                                <div className="course-details-three">
                                    <div className="align-items-center">
                                        <div className="course-count-three course-count ms-0">
                                            <div className="course-content-three">
                                                <h4 className="text-info">
                                                    <span>Programs</span>
                                                </h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-2 col-md-6 d-flex" data-aos="fade-up">
                                <div className="course-details-three">
                                    <div className="align-items-center">
                                        <div className="course-count-three course-count ms-0">
                                            <div className="course-content-three">
                                                <h4 className="text-warning">
                                                    <span>Reliability</span>
                                                </h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-2 col-md-6 d-flex" data-aos="fade-up">
                                <div className="course-details-three">
                                    <div className="align-items-center">
                                        <div className="course-count-three course-count ms-0">
                                            <div className="course-content-three">
                                                <h4 className="text-skyblue">
                                                    <span>Insights</span>
                                                </h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-2 col-md-6 d-flex" data-aos="fade-up">
                                <div className="course-details-three mb-0">
                                    <div className="align-items-center">
                                        <div className="course-count-three">
                                            <div className="course-content-three course-count">
                                                <h4 className="text-success">
                                                    <span>Resources</span>
                                                </h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                             <div className="col-lg-2 col-md-6 d-flex" data-aos="fade-up">
                                <div className="course-details-three mb-0">
                                    <div className="align-items-center">
                                        <div className="course-count-three">
                                            <div className="course-content-three course-count">
                                                <h4 className="text-gray">
                                                    <span>Solutions</span>
                                                </h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                             <div className="col-lg-2 col-md-6 d-flex" data-aos="fade-up">
                                <div className="course-details-three mb-0">
                                    <div className="align-items-center">
                                        <div className="course-count-three">
                                            <div className="course-content-three course-count">
                                                <h4 className="text-pink">
                                                    <span>Benefits</span>
                                                </h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* /Online Courses */}
        </>

    )
}

export default Onlinecourses
